var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20005 8.09995C8.69122 8.09995 9.90005 6.89112 9.90005 5.39995C9.90005 3.90878 8.69122 2.69995 7.20005 2.69995C5.70888 2.69995 4.50005 3.90878 4.50005 5.39995C4.50005 6.89112 5.70888 8.09995 7.20005 8.09995Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20005 9.89995C10.1824 9.89995 12.6 12.3176 12.6 15.3H1.80005C1.80005 12.3176 4.21771 9.89995 7.20005 9.89995Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 6.29995C14.4 5.8029 13.9971 5.39995 13.5 5.39995C13.003 5.39995 12.6 5.8029 12.6 6.29995V7.19995H11.7C11.203 7.19995 10.8 7.60289 10.8 8.09995C10.8 8.59701 11.203 8.99995 11.7 8.99995H12.6V9.89995C12.6 10.397 13.003 10.8 13.5 10.8C13.9971 10.8 14.4 10.397 14.4 9.89995V8.99995H15.3C15.7971 8.99995 16.2 8.59701 16.2 8.09995C16.2 7.6029 15.7971 7.19995 15.3 7.19995H14.4V6.29995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.dc8ce6d14c3a4de20a0ea3a49b024d98.svg";
export { ForwardRef as ReactComponent };